/** @jsx jsx */
import { useState } from 'react'
import { jsx } from 'theme-ui'
import { Container } from '../container'
import BroadbandTvSection from './broadbandTv'
import MobilesSection from './mobile'
import 'animate.css'
import IndustrySection from './industry'

const sections = {
  all: (
    <div className="animate__animated animate__fadeInLeftBig">
      <BroadbandTvSection />
      <MobilesSection />
      <IndustrySection />
    </div>
  ),
  broadband: (
    <div className="animate__animated animate__fadeInRight">
      <BroadbandTvSection />
    </div>
  ),
  mobiles: (
    <div className="animate__animated animate__fadeInLeft">
      <MobilesSection />
    </div>
  ),
  industry: (
    <div className="animate__animated animate__fadeInRight">
      <IndustrySection />
    </div>
  )
}

const FilterButton = ({
  onClick,
  title,
  autoFocus = false,
  mr = ['4px', 16]
}) => (
  <button
    sx={{
      p: 16,
      background: '#FFFFFF',
      border: 'none',
      boxShadow: '0px 4px 8px rgba(20, 20, 36, 0.08)',
      borderRadius: '100px',
      '&:focus': {
        outline: '2px solid #141414',
        color: '#141414',
        fontWeight: 700
      },
      wordBreak: 'keep-all',
      height: 56,
      minHeight: '100%',
      color: '#656565',
      fontSize: '16px',
      lineHeight: '24px',
      mr,
      minWidth: [150, 'auto'],
      mb: ['8px', 0]
    }}
    onClick={onClick}
    autoFocus={autoFocus}
  >
    {title}
  </button>
)

const Winners = () => {
  const [showSection, setShowSection] = useState('all')

  return (
    <section sx={{ pt: [64, 48] }}>
      <Container>
        <div
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 64,
            flexWrap: 'wrap'
          }}
        >
          <FilterButton
            onClick={() => setShowSection('all')}
            title="All awards"
            autoFocus
          />
          <FilterButton
            onClick={() => setShowSection('broadband')}
            title="Broadband & TV"
          />
          <FilterButton
            onClick={() => setShowSection('mobiles')}
            title="Mobile"
          />
          <FilterButton
            onClick={() => setShowSection('industry')}
            title="Industry"
            mr={0}
          />
        </div>

        {sections[showSection]}
      </Container>
    </section>
  )
}

export default Winners
